import { createAsyncThunk } from "@reduxjs/toolkit";
import { OrderAPIService } from "src/constants";
import { sendRequestFiles, sendRequestJSON } from "src/lib/axios";
import { toastMessage } from "../commonSlice";
import {
  IFetchFilteredOrdersPayload,
  IFetchFilteredPaginatedOrdersPayload,
} from "./types";

export const fetchOrders = createAsyncThunk(
  "orders/fetchOrders",
  async (_, { dispatch }) => {
    try {
      const response = await sendRequestJSON(
        null,
        OrderAPIService.GET_ORDERS_LIST,
        "get"
      );
      if (!response.error) {
        const { data } = response?.result?.data;
        return data;
      } else {
        dispatch(
          toastMessage({
            error: true,
            message: response.result.message,
          })
        );
        return [];
      }
    } catch (error) {
      dispatch(
        toastMessage({
          error: true,
          message: error.response.data,
        })
      );
      return [];
    }
  }
);

export const fetchOrdersPagination = createAsyncThunk(
  "orders/fetchOrdersPagination",
  async (payload: IFetchFilteredPaginatedOrdersPayload, { dispatch }) => {
    try {
      const response = await sendRequestJSON(
        null,
        OrderAPIService.GET_ORDERS_LIST_PAGINATION +
          `?pageNumber=${payload.pageNumber}&noOfRows=${payload.noOfRows}&customerName=${payload.customerName}`,
        "get"
      );
      if (!response.error) {
        const { data } = response?.result?.data;
        return data;
      } else {
        dispatch(
          toastMessage({
            error: true,
            message: response.result.message,
          })
        );
        return [];
      }
    } catch (error) {
      dispatch(
        toastMessage({
          error: true,
          message: error.response.data,
        })
      );
      return [];
    }
  }
);

export const fetchOrderIdsByCustomerId = createAsyncThunk(
  "orders/fetchOrderIdsByCustomerId",
  async (customerId: string, { dispatch }) => {
    try {
      const response = await sendRequestJSON(
        {
          customerId,
        },
        OrderAPIService.GET_ORDER_IDS,
        "post"
      );
      if (!response.error) {
        const { data } = response?.result?.data;
        return data;
      } else {
        dispatch(
          toastMessage({
            error: true,
            message: response.result.message,
          })
        );
        return [];
      }
    } catch (error) {
      dispatch(
        toastMessage({
          error: true,
          message: error.response.data,
        })
      );
      return [];
    }
  }
);

export const fetchOrdersByCustomerId = createAsyncThunk(
  "orders/fetchOrdersByCustomerId",
  async (customerId: string, { dispatch }) => {
    try {
      const response = await sendRequestJSON(
        {
          customerId,
        },
        OrderAPIService.GET_ORDER_BY_CUSTOMER_ID,
        "post"
      );
      if (!response.error) {
        const { data } = response?.result?.data;
        return data;
      } else {
        dispatch(
          toastMessage({
            error: true,
            message: response.result.message,
          })
        );
        return [];
      }
    } catch (error) {
      dispatch(
        toastMessage({
          error: true,
          message: error.response.data,
        })
      );
      return [];
    }
  }
);

export const fetchOrderCountByCustomerId = createAsyncThunk(
  "orders/fetchOrderCountByCustomerId",
  async (customerId: string, { dispatch }) => {
    try {
      const response = await sendRequestJSON(
        {
          customerId,
        },
        OrderAPIService.GET_ORDER_COUNT_BY_CUSTOMER_ID,
        "post"
      );
      if (!response.error) {
        const { data } = response.result?.data;
        return data;
      } else {
        dispatch(
          toastMessage({
            error: true,
            message: response.result.message,
          })
        );
        return response.result?.data;
      }
    } catch (error) {
      dispatch(
        toastMessage({
          error: true,
          message: error.response.data,
        })
      );
      return [];
    }
  }
);

export const fetchOrderDetailsById = createAsyncThunk(
  "orders/fetchOrderDetailsById",
  async (orderId: string, { dispatch }) => {
    try {
      const response = await sendRequestJSON(
        {
          orderId,
        },
        OrderAPIService.GET_ORDER_DETAILS,
        "post"
      );
      if (!response.error) {
        const { data } = response.result?.data;
        return data[0];
      } else {
        dispatch(
          toastMessage({
            error: true,
            message: response.result.message,
          })
        );
        return response.result?.data;
      }
    } catch (error) {
      dispatch(
        toastMessage({
          error: true,
          message: error.response.data,
        })
      );
      return [];
    }
  }
);

export const createUpdateOrder = createAsyncThunk(
  "orders/createUpdateOrder",
  async (order: any, { dispatch }) => {
    // console.log("createUpdateOrder order", order);
    try {
      let paymentProofUrl = order?.orderPayment?.paymentProofUrl || null;
      // console.log("Initial Payment Proof URL:", paymentProofUrl);

      if (order.orderPayment?.paymentMode === "Online") {
        const proof = await dispatch(
          uploadPaymentProofAttachment({
            file: order.orderPayment.paymentProofFile[0],
          })
        ).unwrap();
        // console.log(proof, "Uploaded Payment Proof");
        if (!proof) {
          dispatch(
            toastMessage({
              error: true,
              message: "Payment proof upload failed. Order not saved.",
            })
          );
          return false;
        }
        paymentProofUrl = proof.fileUrl; // override with new file URL
      }

      const cleanOrder = JSON.parse(JSON.stringify(order));
      if (cleanOrder.orderPayment?.paymentProofFile) {
        delete cleanOrder.orderPayment.paymentProofFile;
      }
      // Always set lastModifiedBy
      // cleanOrder.orderPayment.lastModifiedBy = "1";
      // cleanOrder.orderPayment.paymentProofUrl = paymentProofUrl;
      if (cleanOrder.orderPayment) {
        cleanOrder.orderPayment.paymentProofUrl = paymentProofUrl;
      }
      // console.log("Final Order Payload:", cleanOrder);

      // API request
      const response = await sendRequestJSON(
        cleanOrder,
        OrderAPIService.CREATE_UPDATE_ORDER,
        "post"
      );

      if (response.error) {
        // console.log(response, "HELLO");

        dispatch(
          toastMessage({
            error: true,
            message: response.result?.message || "Order creation failed",
          })
        );
        return false;
      } else {
        dispatch(
          toastMessage({
            message:
              response.result.data?.message || "Order saved successfully",
          })
        );
      }

      return response.result.data;
    } catch (error: any) {
      // console.log(error, "ERRORRRRRRRRR");

      dispatch(
        toastMessage({
          error: true,
          message: error?.response?.data || "Order creation failed",
        })
      );
      return false;
    }
  }
);

export const uploadPaymentProofAttachment = createAsyncThunk(
  "orders/uploadPaymentProofAttachment",
  async ({ file }: { file: File }, { dispatch }) => {
    try {
      const response = await sendRequestFiles(
        [file],
        OrderAPIService.UPLOAD_PAYMENT_PROOF_ATTACHMENT
      );

      if (response.error) {
        dispatch(
          toastMessage({
            error: true,
            message: response.result?.message || "File upload failed",
          })
        );
        return null;
      }

      // ✅ Correct nested structure
      const paymentProofUrl = response.result.data?.data?.paymentProofUrl;
      // console.log("paymentProofUrl_here", paymentProofUrl);

      if (!paymentProofUrl) {
        dispatch(
          toastMessage({
            error: true,
            message: "No file URL returned from server.",
          })
        );
        return null;
      }

      return {
        fileUrl: paymentProofUrl,
      };
    } catch (error: any) {
      dispatch(
        toastMessage({
          error: true,
          message: error?.response?.data || "File upload failed",
        })
      );
      return null;
    }
  }
);

export const fetchFilteredOrders = createAsyncThunk(
  "orders/fetchFilteredOrders",
  async (filteredOrdersPayload: IFetchFilteredOrdersPayload, { dispatch }) => {
    try {
      const body: any = {
        startDate: filteredOrdersPayload.startDate,
        endDate: filteredOrdersPayload.endDate,
      };

      if (
        filteredOrdersPayload.branchId !== undefined &&
        filteredOrdersPayload.branchId !== -1
      ) {
        body.branchId = filteredOrdersPayload.branchId;
      }

      const response = await sendRequestJSON(
        body,
        OrderAPIService.GET_FILTERED_ORDERS,
        "post"
      );

      if (!response.error) {
        const { data } = response?.result?.data;
        return data;
      } else {
        dispatch(
          toastMessage({
            error: true,
            message: response.result.message,
          })
        );
        return [];
      }
    } catch (error) {
      dispatch(
        toastMessage({
          error: true,
          message: error.response.data,
        })
      );
      return [];
    }
  }
);

export const fetchOrderTrackingById = createAsyncThunk(
  "orders/fetchOrderTrackingById",
  async (orderId: number | string, { dispatch, rejectWithValue }) => {
    try {
      const response = await sendRequestJSON(
        {},
        `${OrderAPIService.GET_ORDER_TRACKING}/${orderId}`,
        "get"
      );

      // ✅ Now that backend returns { success, message, data }
      const data = response?.result?.data?.data ?? null;
      const message =
        response?.result?.data?.message ?? "Failed to load order tracking";

      if (!data) {
        dispatch(
          toastMessage({
            error: true,
            message,
          })
        );
        return rejectWithValue(message);
      }

      // ✅ Return structured data (no nesting, easy to use in frontend)
      return {
        orderId: data.orderId,
        cancelReason: data.cancelReason,
        specialInstructions: data.specialInstructions,
        createdBy: data.createdBy,
        currentStatus: data.currentStatus,
        timeline: data.timeline,
        dueDate: data.dueDate,
      };
    } catch (error: any) {
      const errorMessage =
        error?.response?.data?.message ??
        error?.response?.data ??
        error?.message ??
        "Something went wrong while fetching order tracking";

      dispatch(
        toastMessage({
          error: true,
          message: errorMessage,
        })
      );

      return rejectWithValue(errorMessage);
    }
  }
);
